import * as React from 'react'
import { useHistory, useParams } from 'react-router-dom';
import ProjectMap from '../../JSComponents/ProjectMap'
import styled from 'styled-components';

import { BodyWithMenu } from '../../components/organisms/Menu'
import { getProjectDetailedById } from '../../globals/ApiHooks';
import Project, { ProjectId } from '../../shared/Project';
import { RowFlexBox, ColumnFlexBox } from '../../components/templates/Wrappers'
import { Fb, Linkedin, Mail, Print } from '../../assets/icon/Icons'
import InvestmentDetails from '../Investment/InvestmentDetails'
import ProjectImageSlider from '../../components/molecules/ProjectImageSlider'
import colors from '../../globals/colors';
import { IsHorizontalMobile, useWindowSize } from '../../globals/UIHooks';
import { createEnDaContent, lang, translateContent } from '../../globals/Translations';
import { MobileMax, TabletMax } from '../../globals/UIValues';
import { getProjectStatusUILabel } from '../../shared/ProjectStatus';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import ProjectStatusBox from '../../components/atoms/ProjectStatusBox';
import FBContent from '../../components/templates/FBContent'
import { ErrorPage } from '../Error';
import { ContentType } from '../../shared/Globals';

const Devider = styled.div`
  width: 1px;
  background-color: ${colors.grayText};
  margin-left: 10px;
  margin-right: 10px;
  @media only screen and (max-width: ${MobileMax}px) {
    width: 0px;
  }
`

const AdaptiveFlexBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media only screen and (max-width: ${MobileMax}px) {
    flex-direction: column;
    align-items: center;
  }
`

const SocialLink = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 4px;
`


export const DetailedProjectPage: React.FC = ({ children }) => {
  const history = useHistory()
  let { id } = useParams<{ id: ProjectId }>();
  const [project, setProject] = React.useState<Project>()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)


  const { width } = useWindowSize()


  React.useEffect(() => {
    (async () => {
      setLoading(true)
      const project = await getProjectDetailedById(id)
      if (project && project.projectId) setProject(project)
      else setError(true)
      setLoading(false)
    })()
  }, [])

  const coloumns = IsHorizontalMobile(width) ? "1fr" : "2fr 1fr"

  if (error) return <ErrorPage message={translateContent(createEnDaContent("Could't find project: " + id, "Kunne ikke finde projekt med id: " + id))} />

  const sharUrl = "https://fundbricks.com/projects/" + id
  const facebookShareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURI(sharUrl) + "&amp;src=sdkpreparse"
  const shareSumary = "Fundbricks.com gør det muligt for investorer at udlåne deres formue til attraktive danske ejendomsprojekter til en høj rente og med kort løbetid."
  const shareTitle = project ? translateContent(project.projectTitle) : "Fundbricks project"
  const linkedinShareUrl = "http://www.linkedin.com/shareArticle?mini=false&url=" + encodeURI(sharUrl) + "&title=" + shareTitle + "&summary=" + shareSumary + "&source=fundbricks.com"

  return (
    <BodyWithMenu loading={loading} onlyMobileMenu={true} noBoxShadow={true}>
      <ColumnFlexBox style={{ maxWidth: TabletMax, marginLeft: 'auto', marginRight: 'auto' }}>
        <ColumnFlexBox style={{ alignItems: 'center' }}>
          <h1 style={{ marginTop: 40, textAlign: 'center' }}>{project && translateContent(project.projectTitle)}</h1>
          <AdaptiveFlexBox>
            {project && <ProjectStatusBox status={getProjectStatusUILabel(project)} />}
            <Devider />
            <span style={{ fontWeight: 700, fontSize: 14 }}>{project && lang(TranslatedTerms.BUILDING_FINANCEING)}</span>
            <Devider />
            <RowFlexBox>
              <span>{lang(TranslatedTerms.SHARE_VIA)}</span>
              <SocialLink href={encodeURI(facebookShareUrl)} target="_blank" rel="noopener noreferrer"><Fb /></SocialLink>
              <SocialLink href={linkedinShareUrl} target="_blank" rel="noopener noreferrer"><Linkedin /></SocialLink>
              <SocialLink href={"mailto:?subject=" + shareTitle + " på Fundbricks.com&body=Se projektet her: " + sharUrl} target="_blank" rel="noopener noreferrer"><Mail /></SocialLink>
              <SocialLink href={"/print/projects/" + id} target="_blank" rel="noopener noreferrer"><Print /></SocialLink>
            </RowFlexBox>
          </AdaptiveFlexBox>
        </ColumnFlexBox>
        <div style={{ textAlign: 'center', color: colors.grayText, marginBottom: 32 }}>
          <FBContent content={project ? translateContent(project.projectTeaser) : ''} contentType={ContentType.Markdown} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: coloumns }}>
          <ProjectImageSlider media={project && project.images} />
          <InvestmentDetails project={project} />
        </div>
        <ColumnFlexBox style={{ marginTop: 32 }}>
          <ProjectMap project={project} />
        </ColumnFlexBox>
      </ColumnFlexBox>
    </BodyWithMenu>
  )
};
